<div class="row page-header">
    <div class="col-12">
        <h1>Job Ownerships <small>View and track job ownership items and their progress</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="0" [destroyOnHide]="false">
            <a ngbNavLink>Jobs</a>
        </li>
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Ownerships</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>My Items</a>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Meeting Agendas</a>
        </li>
    </ul>
</div>

<div [hidden]="isInitialLoading || active !== 0">
    <div class="row action-toolbar" style="margin-top: 15px">
        <div class="col-12">
            <form class="form-inline">
                <!--<action-toolbar-count [grid]="jobGrid"></action-toolbar-count>-->
                <!--<action-toolbar-buttons [grid]="jobGrid" [canEdit]="canEdit" [showAdd]="true" [showEdit]="true" [showDelete]="true"></action-toolbar-buttons>-->
                <!--<action-toolbar-search name="search" [(ngModel)]="jobGrid.filter"></action-toolbar-search>-->
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <wj-flex-grid id="gridJob" #gridJob appAutoSize (initialized)="jobGrid.initialize(gridJob)" [itemsSource]="jobGrid.view">
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobFullName'" [width]="300"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Status'"
                    [binding]="'jobStatus'"
                    [width]="120"
                    [dataMap]="jobStatusMap"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hot'" [binding]="'hotCount'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Off Track'" [binding]="'offTrackCount'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Late'" [binding]="'lateCount'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Due Soon'" [binding]="'dueSoonCount'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'PM'" [binding]="'pmUserId'" [dataMap]="allUserMap" [width]="200"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Site Super'"
                    [binding]="'siteSuperUserId'"
                    [dataMap]="allUserMap"
                    [width]="200"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'PE'" [binding]="'peUserId'" [dataMap]="allUserMap" [width]="200"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'JCA'" [binding]="'jcaUserId'" [dataMap]="allUserMap" [width]="200"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>

<div [hidden]="isInitialLoading || active !== 1">
    <div class="row" style="margin-top: 15px">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <!--<action-toolbar-count [grid]="grid"></action-toolbar-count>-->
                        <wj-combo-box
                            [(ngModel)]="selectedJob"
                            name="selectedJob"
                            (ngModelChange)="jobChanged()"
                            style="width: 400px"
                            [itemsSource]="jobMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>

                        <wj-combo-box
                            [(ngModel)]="selectedTaskName"
                            name="selectedTaskName"
                            (ngModelChange)="taskNameChanged()"
                            style="width: 400px; margin-left: 10px"
                            [itemsSource]="taskNameMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [hidden]="selectedJob() !== 'all'"
                        ></wj-combo-box>

                        <button
                            class="btn btn-secondary btn-sm"
                            (click)="openAddJobOwnershipTemplateModal()"
                            [hidden]="hideJobRelatedButtons()"
                        >
                            Add Items from Template
                        </button>

                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEditProject"
                            [showAdd]="!hideJobRelatedButtons()"
                            [showEdit]="true"
                            [showDelete]="true"
                            [hidden]="hideNonJobRelatedButtons()"
                        ></action-toolbar-buttons>
                    </form>
                </div>
            </div>
            <div class="row" [hidden]="hideNonJobRelatedButtons()">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemFormatter]="mainGridItemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="' '" [binding]="'isHot'" [width]="50" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <div style="text-align: center; cursor: pointer" (click)="toggleHot(cell)">
                                    <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                                </div>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'jobFullName'"
                            [width]="'*'"
                            [visible]="selectedJob() === 'all'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Name'"
                            [binding]="'name'"
                            [width]="'*'"
                            [isReadOnly]="!canEditProject"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Status'"
                            [binding]="'status'"
                            [dataMap]="statusMap"
                            [width]="120"
                            [isRequired]="false"
                            [isReadOnly]="!canEditProject"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Ownership'"
                            [binding]="'assignedUserId'"
                            [dataMap]="allUserMap"
                            [width]="250"
                            [isRequired]="false"
                            [isReadOnly]="!canEditProject"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Due Date'"
                            [binding]="'dueDate'"
                            [width]="120"
                            [editor]="inputDate"
                            [isRequired]="false"
                            [isReadOnly]="!canEditProject"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Done Date'"
                            [binding]="'doneDate'"
                            [width]="120"
                            [editor]="inputDate"
                            [isRequired]="false"
                            [isReadOnly]="!canEditProject"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'2*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
</div>

<div [hidden]="isInitialLoading || active !== 2">
    <div class="row" style="margin-top: 15px">
        <div class="col-12">
            <wj-flex-grid
                id="gridMyItems"
                #gridMyItems
                appAutoSize
                (initialized)="myItemsGrid.initialize(gridMyItems)"
                (destroy)="myItemsGrid.destroy()"
                [itemsSource]="myItemsGrid.view"
                (cellEditEnded)="cellEditEnded(gridMyItems, $event)"
                (pasting)="pasting(gridMyItems, $event)"
                (pasted)="pasted(gridMyItems, $event)"
                [itemFormatter]="mainGridItemFormatter"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="' '" [binding]="'isHot'" [width]="50" [isReadOnly]="true">
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        <div style="text-align: center; cursor: pointer" (click)="toggleHot(cell)">
                            <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobFullName'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Status'"
                    [binding]="'status'"
                    [dataMap]="statusMap"
                    [width]="120"
                    [isRequired]="false"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Due Date'"
                    [binding]="'dueDate'"
                    [width]="120"
                    [editor]="inputDate"
                    [isRequired]="false"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Done Date'"
                    [binding]="'doneDate'"
                    [width]="120"
                    [editor]="inputDate"
                    [isRequired]="false"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'2*'"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>

<div [hidden]="active !== 3">
    <div class="row action-toolbar" style="margin-top: 15px">
        <div class="col-12">
            <form class="form-inline">
                <wj-combo-box
                    [(ngModel)]="selectedAgenda"
                    name="selectedAgenda"
                    style="width: 250px"
                    [itemsSource]="availableAgendas"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </form>
        </div>
    </div>

    <div class="row" [hidden]="selectedAgenda !== 0">
        <div class="col-lg-12 agenda">
            <h3>Overall, Agenda Kickoff Meeting: (1.5 to 3 Hours Depending on Project) (Conducted by Leadership Team)</h3>
            <ol>
                <li>Accounting/HR/Safety Compliance Review (i.e. certified payroll, JCA’s, HR needs, special Safety requirements)</li>
                <li>Assign Ownership Chart Responsibilities (Project Manager 10 Minutes)</li>
                <li>
                    Review current VanCon Overall Company Backlog and how this project fits into backlog and other project visions. (10
                    Minutes)
                </li>
                <li>Estimator Handoff (5-10 Minutes)</li>
                <li>
                    Implement Project Manager and Superintendent Template Structures and finalize roles and responsibilities. (5 Minutes)
                </li>
                <li>Assign Project Priority Number (5 Minutes)</li>
                <li>
                    Project Review (15-30 minutes)
                    <ol type="a">
                        <li>Start Date</li>
                        <li>Completion Date</li>
                        <li>Key Milestones if applicable</li>
                        <li>Stakeholders</li>
                        <li>Public Relations</li>
                        <li>Working Restrictions if applicable</li>
                        <li>Liquidated Damages: Repercussions</li>
                        <li>Material Availability</li>
                        <li>
                            Lead Times
                            <ol type="i">
                                <li>Key Specialty Equipment</li>
                                <li>Project Material Checklist sheets based on project category.</li>
                                <li>Other</li>
                            </ol>
                        </li>
                        <li>Subcontractors</li>
                        <li>Electrical/Scada coordination</li>
                        <li>Other</li>
                    </ol>
                </li>
                <li>
                    Project Layout & Vision for Work Sequence (15-30 minutes)
                    <ol type="i">
                        <li>P6 schedule discussions, assignments on who is responsible for the schedule and 3 week look ahead.</li>
                    </ol>
                </li>
                <li>
                    Project Labor & Equipment Priorities (15 Minutes)
                    <ol type="a">
                        <li>Identify Departments needed for project.</li>
                        <li>Identify specific crews for the project and timetable.</li>
                        <li>Review Yellow Iron needed for project.</li>
                        <li>Review Trucking needed and if leasing required.</li>
                        <li>Project Hand Tools, Connex, Trailer, and consumables needed for the project.</li>
                    </ol>
                </li>
                <li>
                    Finalize Project Vision (15 Minutes)
                    <ol type="a">
                        <li>EVERYONE AGREES AND NO ONE LOOKS BACK!!</li>
                    </ol>
                </li>
                <li>
                    Assign Recording of Vision (5 Minutes)
                    <ol type="a">
                        <li>Project Overview: Leadership Team</li>
                        <li>Project Team: Executive Team</li>
                        <li>Project Review: Project Manager</li>
                        <li>Project Layout & Work Sequence: Project Manager/Site Superintendent</li>
                        <li>Project Labor & Equipment: Site Superintendent</li>
                    </ol>
                </li>
                <li>Video Record Vision (15 Minutes)</li>
                <li>Post on VanCon Media Outlet for everyone to see. (5 Minutes)</li>
            </ol>
        </div>
    </div>
    <div class="row" [hidden]="selectedAgenda !== 1">
        <div class="col-lg-12 agenda">
            <h3>
                Overall, Vision Agenda 25%, 50%, 75% and or Quarterly Meeting: (2-3 Hours Depending on Project) (Conducted by Project
                Manager/Site Superintendent)
            </h3>
            <ol>
                <li>Review Project Vision and if still applicable and if vision adjustments are required. (15 Minutes)</li>
                <li>Establish Project Rocks for next 90 days! (30 Minutes)</li>
                <li>
                    Review Project Buyout and discuss any savings or overages and how it impacts profitability of the project. (15 Minutes)
                </li>
                <li>
                    Review Production Analysis Report on Labor & Equipment and see if changes are needed to come within budget. (30 Minutes)
                    <ol>
                        <li>Look at crews and provide feedback on production analysis.</li>
                        <li>Review Equipment needs and forecast remaining needs.</li>
                    </ol>
                </li>
                <li>Discuss Owner relationship and provide feedback (5 Minutes)</li>
                <li>
                    Review Purchase Orders & Material items and schedule for long lead items and potential delays that could impact
                    schedule. (10 Minutes)
                </li>
                <li>Review Subcontractors and status of work any delay implications.</li>
                <li>Update Project Vision (10 Minutes)</li>
                <li>Re-record Project Vision if needed. (15 Minutes)</li>
                <li>Post on VanCon Media Outlet for everyone to see if Vision is updated. (5 Minutes)</li>
            </ol>
        </div>
    </div>
    <div class="row" [hidden]="selectedAgenda !== 2">
        <div class="col-lg-12 agenda">
            <h3>
                Overall Agenda Closeout Meeting: (1.5 to 2 Hours Depending on Project) (Conducted by Project Manager/Site Superintendent)
            </h3>
            <ol>
                <li>Project Vision: was it followed and how many times did it get adjusted (Did the team get it right) (5 Minutes)</li>
                <li>Project discussion and overall project success (15 Minutes)</li>
                <li>
                    Review Financials of the Project (20 Minutes)
                    <ol>
                        <li>Where was the money made and lost on the project?</li>
                    </ol>
                </li>
                <li>
                    Lessons learned in each aspect of the project for Estimator feedback to improve estimates. (30-60 Minutes)
                    <ol>
                        <li>Labor Estimates</li>
                        <li>Equipment Estimates</li>
                        <li>Crew Composition</li>
                        <li>Material Buyout (Good & Bad Suppliers)</li>
                        <li>Subcontractors (Good & Bad Subcontractors)</li>
                        <li>Management Team composition (review of the hours for that type of project)</li>
                    </ol>
                </li>
                <li>Will the Owner/Engineer provide a good reference? (5 Minutes)</li>
                <li>Do we want to continue doing projects like this in the future? (10 Minutes)</li>
            </ol>
        </div>
    </div>
    <div class="row" [hidden]="selectedAgenda !== 3">
        <div class="col-lg-12 agenda">
            <h3>Monthly Vision Meeting Agenda: (1 Hour) (Conducted by Project Manager)</h3>
            <ol>
                <li>Review Project Rocks and are they on track to complete on time. (5-10 Minutes)</li>
                <li>Make assignments/tasks to complete Project Rocks. (10-15 Minutes)</li>
                <li>Review and adjust Labor & Equipment as needed to complete rocks. (10 Minutes)</li>
                <li>
                    Complete coordination between Site Superintendents and People Superintendents to complete the monthly work required. (15
                    Minutes)
                </li>
                <li>Review project schedule and update. (Project Engineer to Update and submit) (10 Minutes)</li>
                <li>Review project compliance with JCA (10 Minutes)</li>
                <li style="text-decoration: underline">
                    Superintendents communicate to Foreman and Crews status of rocks and provide look ahead for the project.
                </li>
            </ol>
        </div>
    </div>
    <div class="row" [hidden]="selectedAgenda !== 4">
        <div class="col-lg-12 agenda">
            <h3>Weekly Progress Meeting Agenda: (30 Minutes to 1 Hour) (Conducted by Site Superintendent)</h3>
            <ol>
                <li>Wins for the Week (5 Minutes)</li>
                <li>Items/Communication that need improvement. (5 Minutes)</li>
                <li>
                    Labor & Equipment resource review (10-15 Minutes)
                    <ol>
                        <li>Hours vs Dollars review by cost codes being used.</li>
                    </ol>
                </li>
                <li>Subcontractor/Supplier coordination needed (5-10 Minutes)</li>
                <li>
                    Project Rock tracking (5-10 Minutes)
                    <ol>
                        <li>Look at tasks to complete in the next 30 days.</li>
                    </ol>
                </li>
                <li>Review critical path schedule and adjust as needed. (5-10 Minutes)</li>
                <li>
                    Assign tasks for the week. (5-10 Minutes)
                    <ol>
                        <li>Everyone leaves with a task assigned for the week!</li>
                    </ol>
                </li>
            </ol>
        </div>
    </div>
</div>
